import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
var tokenid = localStorage.getItem("tokenid");



export const getSyllabusListSvc = (cbSyllabusList) => {
  const obj = { status: "", message: "" };
  axios({
    url: httpURL + '/sms/exam_syllabus/list',
    method: "POST",
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log("response in getSyllabusListSvc", response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstSyllabus = response.data.lstSyllabus;
    }
    cbSyllabusList(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    cbSyllabusList(obj);
  })
}


export function getLstExamSvc(callback) {
  // console.log("getLstExamSvc called");
  axios({
    url: httpURL + '/sms/performance/mst/exam/list',
    method: 'POST',
    params: {},
    headers: { tokenid: tokenid },
    withCredentials: true
  })
    .then(response => {
      // console.log("response in getLstExamSvc", response);
      // console.log('data.SvcStatus=' + response.data.SvcStatus)
      callback(response.data);
    })
    .catch(error => {
      callback(error);
    })
}

export const getExamSyllabusSubjectList = (examId, syllabusId, callback) => {
  // console.log("getExamSyllabusSubjectList called");
  const formData = new FormData();
  formData.append('examId', examId);
  formData.append('syllabusId', syllabusId);
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURL + '/sms/perf/exam/subject/list',
    method: "POST",
    data: formData,
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log('response in getExamSyllabusSubjectList', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstSubject = response.data.lstSubject;
    }
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}


export const getSyllabusPatternList = (callback) => {
  // console.log("getSyllabusPatternList called");
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURL + '/sms/qp/list_pattern',
    method: "POST",
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log('response in getSyllabusPatternList', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    if (response.data.SvcStatus === "Success") {
      obj.lstPattern = response.data.lstPattern;
    }
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}

export const saveExamPatternSvc = (saveExamSubjectPattern, callback) => {
  // console.log("saveExamPatternSvc called");
  const formData = new FormData();
  formData.append("saveExamSubjectPattern", JSON.stringify(saveExamSubjectPattern));
  var obj = { status: "Success", message: "" }
  axios({
    url: httpURL + '/sms/perf/exam/subject/save',
    method: "POST",
    data:formData,
    headers: { 'tokenid': tokenid },
    withCredentials: true,
  }).then((response) => {
    // console.log('response in getSyllabusPatternList', response);
    obj.status = response.data.SvcStatus;
    obj.message = response.data.SvcMsg;
    callback(obj);
  }).catch((error) => {
    obj.status = "Exception";
    obj.message = error;
    callback(obj);
  });
}

